import React, { Component } from 'react';

export default class view extends Component {
	render() {
		return (
			<div  style={{textAlign:'left', overflowWrap: 'break-word' }}>
				<p>This patient has only been authorized for an Inborn Metabolic formula. The code you have entered is not a valid code for Inborn Metabolic formula. </p>
				
				<div className="button" onClick={()=>this.props.navigate('D8')}>Go Back</div>
			</div>
		);
	}
}